// extracted by mini-css-extract-plugin
export var NoImage = "Card-module--NoImage--1f845";
export var NoImageCard = "Card-module--NoImageCard--4949b";
export var author = "Card-module--author--e20c8";
export var card = "Card-module--card--59c02";
export var card__skeleton = "Card-module--card__skeleton--8bf46";
export var category = "Card-module--category--4eb32";
export var featured = "Card-module--featured--a6900";
export var featuredCard = "Card-module--featuredCard--ee17a";
export var horizontalCard = "Card-module--horizontalCard--73009";
export var horizontalCard__image = "Card-module--horizontalCard__image--71f36";
export var image = "Card-module--image--89dce";
export var imageContainer = "Card-module--imageContainer--7fb9c";
export var info = "Card-module--info--078c3";
export var inner = "Card-module--inner--c2daf";
export var main = "Card-module--main--ba9b8";
export var separator = "Card-module--separator--d8d1f";
export var summary = "Card-module--summary--bd5df";
export var time = "Card-module--time--b2c67";
export var title = "Card-module--title--ba3db";
export var top = "Card-module--top--5ec22";